import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/conversation-exports',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::index
* @see app/Http/Controllers/Admin/ConversationExportController.php:18
* @route '/app/conversation-exports'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::store
* @see app/Http/Controllers/Admin/ConversationExportController.php:47
* @route '/app/conversation-exports'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/conversation-exports',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::store
* @see app/Http/Controllers/Admin/ConversationExportController.php:47
* @route '/app/conversation-exports'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::store
* @see app/Http/Controllers/Admin/ConversationExportController.php:47
* @route '/app/conversation-exports'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::store
* @see app/Http/Controllers/Admin/ConversationExportController.php:47
* @route '/app/conversation-exports'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::store
* @see app/Http/Controllers/Admin/ConversationExportController.php:47
* @route '/app/conversation-exports'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
export const download = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/app/conversation-exports/{conversationExport}/download',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
download.url = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversationExport: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { conversationExport: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            conversationExport: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversationExport: typeof args.conversationExport === 'object'
        ? args.conversationExport.id
        : args.conversationExport,
    }

    return download.definition.url
            .replace('{conversationExport}', parsedArgs.conversationExport.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
download.get = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
download.head = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
const downloadForm = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
downloadForm.get = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ConversationExportController::download
* @see app/Http/Controllers/Admin/ConversationExportController.php:80
* @route '/app/conversation-exports/{conversationExport}/download'
*/
downloadForm.head = (args: { conversationExport: string | { id: string } } | [conversationExport: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

download.form = downloadForm

const exportMethod = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    download: Object.assign(download, download),
}

export default exportMethod